var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "reveal-query-input-wrap" }, [
    _c("div", { staticClass: "reveal-query-criteria-slot" }, [
      _c(
        "label",
        {
          staticClass: "sr-only",
          attrs: { for: "reveal-search-criteria-select" },
        },
        [_vm._v("Search criteria")]
      ),
      _c(
        "select",
        {
          staticClass:
            "form-control form-control-sm reveal-query-criteria-select",
          attrs: { id: "reveal-search-criteria-select" },
          domProps: { value: _vm.searchCriteriaType },
          on: {
            change: function ($event) {
              return _vm.onCriteriaChange($event.target.value)
            },
          },
        },
        _vm._l(_vm.searchCriteriaOptions, function (opt) {
          return _c(
            "option",
            {
              key: opt.value,
              attrs: { disabled: !opt.enabled },
              domProps: { value: opt.value },
            },
            [_vm._v(" " + _vm._s(opt.label) + " ")]
          )
        }),
        0
      ),
    ]),
    _c("input", {
      ref: "queryInput",
      staticClass: "form-control reveal-query-text-input",
      attrs: { type: "text", placeholder: _vm.searchInputPlaceholder },
      domProps: { value: _vm.userQuery },
      on: {
        input: function ($event) {
          return _vm.$emit("update:userQuery", $event.target.value)
        },
        focus: function ($event) {
          return _vm.$emit("query-focus")
        },
        blur: function ($event) {
          return _vm.$emit("query-blur")
        },
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.$emit("reveal")
        },
      },
    }),
    _c("div", { staticClass: "reveal-query-input-actions" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-cfde reveal-query-submit-btn",
          staticStyle: { "min-width": "120px" },
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("reveal")
            },
          },
        },
        [_vm._v(" Reveal ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }